import React from 'react'
import { Elements, ElementsConsumer, IbanElement } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import './IbanForm.styles.css'
import { connect } from 'react-redux'
import { handleSubmit } from './IbanForm.services'
import Modal from '../Modal'
import stripeCustomApiKeyValue from '../../constants/stripe'

let stripePromise = null;

const IBAN_STYLE = {
  base: {
    color: '#32325d',
    fontSize: '16px',
    '::placeholder': {
      color: '#aab7c4'
    },
    ':-webkit-autofill': {
      color: '#32325d'
    }
  },
  invalid: {
    color: '#dc3545',
    iconColor: '#dc3545',
    borderColor: '#dc3545',
    ':-webkit-autofill': {
      color: '#dc3545'
    }
  }
};

const IBAN_ELEMENT_OPTIONS = {
  supportedCountries: ['SEPA'],
  placeholderCountry: 'FR',
  style: IBAN_STYLE
};

class IbanForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLaunchingModal: false,
      agreement: false,
      validationMessage: {
        agreement: null
      },
      isLoadingData: false
    };
  }

  loadStripe = async () => {
    stripePromise = loadStripe(await stripeCustomApiKeyValue())
  };

  async componentWillMount() {
    const { showLaunchingModal } = this.props;
    await this.loadStripe();
    this.setState(prevState => ({
      showLaunchingModal
    }));
  }

  componentWillReceiveProps(props) {
    const { showLaunchingModal } = props;
    this.setState({ showLaunchingModal });
  }

  renderForm = () => {
    const { agreement, validationMessage } = this.state;
    return (
      <form>
        <div>
          <IbanElement options={IBAN_ELEMENT_OPTIONS} onChange={this.handleChange} />

          <div
            className='form-check mt-3'
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              paddingLeft: '2rem'
            }}
          >
            <input
              style={{
                position: 'absolute',
                marginLeft: '-1.25rem',
                height: 'auto'
              }}
              type='checkbox'
              value={agreement}
              id='agreement'
              className={`${validationMessage.agreement} form-check-input form-checks stripeInput`}
              onClick={() =>
                this.setState(prevState => {
                  const { validationMessage, agreement } = prevState;
                  return {
                    agreement: !agreement,
                    validationMessage: {
                      ...validationMessage,
                      agreement: !agreement ? 'is-valid' : 'is-invalid'
                    }
                  };
                })
              }
            />
            <label className='form-check-label' style={{ paddingLeft: '10px' }}>
              J'ai lu et accepte les conditions générales de{' '}
              <a href='https://stripe.com/fr/legal' target='_blank' rel='noreferrer'>
                stripe
              </a>
              , fournisseur de paiement
            </label>
          </div>
          <div style={{ paddingLeft: '10px', paddingRight: '10px', marginTop: '18px' }}>
            <p style={{ fontSize: '12px', color: 'red' }}>
              * Après enregistrement des informations vous serez redirigé vers un lien hébergé par
              Stripe pour finaliser la validation de votre compte
            </p>
          </div>
        </div>
      </form>
    );
  };

  render() {
    const { showLaunchingModal, isLoadingData } = this.state;
    return (
      <>
        <Elements stripe={stripePromise}>
          <ElementsConsumer>
            {({ stripe, elements }) => (
              <Modal
                isOpen={showLaunchingModal}
                title='IBAN'
                fixed
                header
                showCancelBtn
                handleClose={this.props.onClose}
                btnTxt='Enregistrer'
                onClick={e => handleSubmit(e, stripe, elements, this)}
                loading={isLoadingData}
              >
                <>{this.renderForm(stripe, elements)}</>
              </Modal>
            )}
          </ElementsConsumer>
        </Elements>
      </>
    );
  }
}

const mapStateToProps = ({ componentReducer, firebaseRealTime }) => {
  const { shop = {} } = firebaseRealTime;
  const { modal } = componentReducer;
  return {
    modal,
    shop
  };
};

export default connect(mapStateToProps, {})(IbanForm);
